export default __webpack_public_path__ + "static/media/icon-11.3a6239e3.png";